// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
input,
select,
textarea {
  border: 2px solid #6b8e76 !important;
}

/* .modal-content {
    max-height: 650px;
}

.modal-body {
    max-height: 700px;
    overflow-y: auto;
}  */
.modal-body-scroll {
  max-height: 60vh;
  /* Limits height and makes content scroll */
  overflow-y: auto;
  padding-top: 60px;
  /* To prevent overlap with fixed header */
  padding-bottom: 60px;
  /* To prevent overlap with fixed footer */
}

.fixed-top {
  position: sticky;
  top: 0;
  z-index: 1050;
  padding: 10px;
}

.fixed-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1050;
  padding: 10px;
}

/* modal .dropdown-menu */
.drop {
  height: 40px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ced4da;
  border-radius: 5px;
  padding: 10px 15px;
  font-size: 16px;
  background-color: white;
}

/* Blur effect when modal is open */
.modal-open .main-content {
  filter: blur(10px);
  transition: filter 0.3s ease-in-out;
  pointer-events: none;
}

/* Enhanced blur effect on modal backdrop */
.modal-backdrop.show {
  backdrop-filter: blur(5px);
  /* Increase blur for better effect */
  background-color: rgba(0, 0, 0, 0.7);
  /* Slightly reduce opacity */
  transition:
    backdrop-filter 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
  pointer-events: auto;
  /* Ensures clicks outside modal still work */
}

.drop::after {
  margin-top: -2px;
}

.dropdown-menu {
  width: 100% !important;
}

/* modal .dropdown-menu */

.ChieldComponent {
  background-color: #f5f2e7;
  width: 100%;
  min-height: 100vh;
  padding: 30px;
}

.InfluancerCardView .InfluencerProfile {
  text-align: center;
  width: 120px;
  color: #676767;
  font-weight: 500;
  font-size: 16px;
}

.InfluancerCardView .InfluencerProfile h4 {
  font-size: 20px;
  margin-top: 10px;
  display: block;
  color: #676767;
  font-weight: 500;
  font-size: 16px;
}

.InfluancerCardView .InfluencerProfile img {
  margin-bottom: 10px;
}

.InfluancerCardView .influencer-card {
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 20px 50px;
  align-items: center;
  box-shadow: 1px 1px 10px rgb(0 0 0 / 7%);
  border-radius: 15px;
  margin-top: 20px;
}

.InfluancerCardView .InfluencerFollowes {
  font-size: 16px !important;
  font-weight: 500;
  color: #676767 !important;
  display: flex;
  align-items: center;
  line-height: 20px !important;
  width: 240px;
  text-align: center;
  justify-content: center;
}

.InfluancerCardView .Shorting label {
  color: #676767;
  font-size: 18px;
  font-weight: 400;
}

.InfluancerCardView .InfluencerGenre {
  color: #676767;
  font-size: 16px;
  font-weight: 500;
  width: 150px;
  text-align: center;
}

.InfluancerCardView .InfluencerEngagement {
  width: 150px;
  color: #676767;
  font-weight: 500;
  font-size: 16px;
}

.InfluancerCardView .engagement {
  width: 200px;
  text-align: center;
  color: #676767;
  font-weight: 500;
  font-size: 16px;
}

.InfluancerCardView .engagement span {
  font-size: 24px;
  color: #6b8e76;
  font-weight: 600;
}

.InfluancerCardView .influencer-list {
  margin-bottom: 20px;
}

@media (max-width: 767px) {
  .SearchFilterSection {
    display: flex;
    flex-direction: column;
  }
}

.SearchFilterSection {
  display: flex;
}

.SearchFilterSection input {
  width: 260px;
}

.SearchFilterSection button,
.SearchFilterSection input {
  margin-left: 20px;
  background-color: #fff;
  box-shadow: 1px 1px 6px rgb(0 0 0 / 10%);
  border: 0;
  border-radius: 6px;
  font-size: 16px;
  padding: 9px 20px;
  font-weight: 400;
  color: #676767;
}

.InfluancerCardView .InfluencerEngagement p {
  color: #6b4750;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 6px !important;
}

.InfluancerCardView .InfluencerFollowes span.audience-icon {
  margin-right: 16px;
}

.InfluancerCardView .influencer-list img {
  cursor: pointer;
}

.SearchInput {
  position: relative;
}

.SearchInput img {
  position: absolute;
  left: 30px;
  top: 15px;
}

.SearchInput input {
  padding: 10px 40px;
}

.InfluencerGridList {
  background: #fff;
  width: max-content;
  box-shadow: 1px 1px 10px rgb(0 0 0 / 12%);
  border-radius: 17px;
  padding: 10px;
  height: 100%;
}

/* filter-popup */

.filter-popup {
  position: fixed;
  top: 150px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: end;
  z-index: 1000;
}

.filter-popup:before {
  content: "";
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: #0000009e;
  min-height: 100vh;
}

.filter-popup .filter-popup-content {
  background: #fff;
  padding: 0px;
  border-radius: 10px;
  width: 300px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
}

.filter-popup .filter-popup-content h3 {
  margin-top: 0;
}

.filter-popup .close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.filter-popup .clear-btn {
  position: absolute;
  top: 10px;
  right: 40px;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: white;
}

.filter-options {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
}

.filter-popup .apply-filters-btn {
  margin-top: 20px;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.filter-popup .filter-popup-content {
  background: #f5f2e7;
  padding: 0px;
  border-radius: 10px;
  width: 300px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
  width: 100%;
  max-width: 500px;
  border-radius: 10px;
  margin-right: 25px;
}

.filter-popup ul.nav.nav-pills li {
  display: block;
  width: 100%;
  background: #fff;
}

.filter-popup ul.nav.nav-pills {
  width: 210px;
  background: #fff;
}

.filter-popup ul.nav.nav-pills li {
  border-bottom: 1px solid #767676;
}

.filter-popup ul.nav.nav-pills li a {
  text-decoration: none;
  color: #676767;
  font-weight: 400;
  font-size: 20px;
  line-height: 60px;
  text-align: center;
  padding: 0 15px;
}

.filter-popup ul.nav.nav-pills li {
  display: block;
  width: 100%;
  background: #fff;
}

.filter-popup ul.nav.nav-pills {
  width: 210px;
  background: #fff;
}

.filter-popup ul.nav.nav-pills li {
  border-bottom: 1px solid #767676;
}

.filter-popup ul.nav.nav-pills li a {
  text-decoration: none;
  color: #676767;
  font-weight: 400;
  font-size: 20px;
  line-height: 60px;
  text-align: center;
  padding: 0 15px;
}

.filter-popup .filter-options label {
  padding: 8px 0;
  font-size: 14px;
  font-weight: 400;
}

.filter-popup .form-check input {
  height: 20px;
  width: 20px;
  margin-right: 10px;
  border: 3px solid #6b8e76;
  background: transparent;
}

.filter-popup .form-check {
  display: flex;
  align-items: center;
}

.filter-popup ul.nav.nav-pills li h6 {
  padding: 14px 20px;
  text-align: center;
  font-size: 20px;
  color: #6b8e76;
  font-weight: 600;
}

.filter-popup .FilterHeader {
  display: flex;
  width: 100%;
  background: #fff;
  padding: 9px 30px;
}

.filter-popup button.btn.btn-primary.mt-3 {
  background: #6b8e76;
  border: 0;
  width: max-content;
  padding: 10px 30px;
}

.filter-popup .Filters {
  display: flex;
  height: 460px;
  overflow-y: auto;
}

.filter-popup .FilterHeader {
  display: flex;
  width: 100%;
  background: rgba(107, 142, 118, 1);
  padding: 9px 30px;
  border-radius: 10px 10px 0 0;
}

.filter-popup .form-check {
  display: flex;
  align-items: center;
}

.filter-popup .FilterHeader h6 {
  width: 113px;
  color: rgba(245, 242, 231, 1);
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  font-size: 20px;
}

.filter-popup li.SearchFilter input {
  border: 0;
}

.filter-popup li.SearchFilter {
  padding: 5px 20px;
}

.filter-popup i.SearchFilter img {
  left: -3px;
  top: 3px;
}

.filter-popup li.SearchFilter input {
  border: 0;
  padding: 0 26px;
}

.filter-popup .SearchInput img {
  position: absolute;
  left: 0px;
  top: 3px;
}

.BtnsGrp {
  margin-top: auto;
  /* Pushes the button group to the bottom */
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: rgba(107, 142, 118, 1);
}

.Shorting .Sort {
  height: 14px;
  margin-left: 10px;
}

.TableBox {
  height: calc(100vh - 8em);
  overflow-y: auto;
}

.Shorting.influencer-list .influencer-card {
  margin: 0 !important;
  background: transparent;
  box-shadow: 0 0 0;
  padding: 0 0 15px 50px;
}

.Shorting.influencer-list {
  margin: 0;
}

.InfluencerGridList {
  background: #fff;
  width: 100%;
  box-shadow: 1px 1px 10px rgb(0 0 0 / 12%);
  border-radius: 17px;
  padding: 10px;
}

.InfluencerGridList .ImgBox img {
  width: 100%;
}

.InfluencerGridList .Name h6 {
  font-size: 20px;
  font-weight: 600;
  color: #676767;
  padding: 9px 0;
}

.InfluencerGridList .Name {
  margin-top: 20px;
}

.InfluencerGridList .Dats {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.InfluencerGridList .Dats div span {
  display: block;
}

.InfluencerGridList .Dats div span {
  display: block;
  color: #6b8e76;
  font-size: 16px;
  font-weight: 600;
}

.InfluencerGridList .Dats div {
  text-align: center;
}

.InfluencerGridList .Dats div strong {
  color: #676767;
  font-size: 16px;
  font-weight: 500;
}

.InfluencerGridList .Dats div .follower-text-lg {
  color: #0c0c0c;
  font-size: 16px;
  font-weight: 500;
}

.SocialPresence {
  padding: 0 15px;
}

.InfluencerGridList .Name {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 15px;
}

.ImgBox {
  background: #fbfbfb;
  border-radius: 15px;
}

.InfluencerGridList .Dats div {
  text-align: center;
}

strong {
  color: #676767;
  font-size: 16px;
  font-weight: 500;
}

.ImgBox {
  background: #fbfbfb;
  border-radius: 15px;
  position: relative;
  position: relative;
}

.Genuine {
  position: absolute;
  top: 0;
  right: 0;
  height: 40px;
  width: 40px;
  background: #fff;
  text-align: center;
  line-height: 36px;
  border-radius: 50%;
  border: 2px solid #6b8e76 !important;
  color: #6b8e76;
  font-weight: 700;
  font-size: 18px;
}

.Genuine span {
  position: absolute;
  height: 18px;
  width: 18px;
  right: -6px;
  color: #6b8e76;
  top: -2px;
  background: #fcfcfc;
  font-size: 15px;
  line-height: 15px;
  border-radius: 50%;
  font-weight: 700;
}

.Genuine h6 {
  font-size: 12px;
  text-align: center;
  position: relative;
  left: -4px;
  top: 42px;
  font-weight: 700;
}

.form-group label {
  color: #676767;
  font-size: 24px;
  font-weight: 500;
}

.ProfileBanner {
  background: #fff;
  padding: 20px 21px;
  border-radius: 10px;
  box-shadow: 1px 1px 10px rgb(0 0 0 / 15%);
  border: 1px solid #111;
}

.ProfileDetails {
  box-shadow: 1px 1px 10px rgb(0 0 0 / 15%);
  background: #fff;
  border: 1px solid #111;
  padding: 20px;
  margin-top: 20px;
  border-radius: 10px;
}

h2.h6 {
  color: #6b8e76;
  font-size: 24px;
  font-weight: 600;
  margin-top: 20px;
  display: block;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
  display: flex;
  align-items: center;
}

.list-unstyled div {
  margin-right: 30px;
}

.list-unstyled div a {
  text-decoration: none;
}

h2.h6 {
  color: #6b8e76;
  font-size: 24px;
  font-weight: 600;
  margin-top: 20px !important;
  display: block;
  margin-bottom: 15px !important;
}

.list-unstyled div svg {
  border: 1px solid #ddd;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  object-fit: contain;
  padding: 7px;
}

.ProfileDetails h1 {
  position: auto !important;
}

.ProfileEditLogo img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 30px;
  aspect-ratio: 1 / 1;
}

.ProfileEditLogo {
  display: flex;
  align-items: center;
  font-family: "Poppins", serif;
}

.ProfileEditLogo h1.h5 {
  font-size: 48px;
  font-family: "Poppins", serif;
  font-weight: 500;
  color: #6b8e76;
}

/* Basic Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.MyProfile {
  font-family: "Poppins", serif;
}

/* General Styles */
.container-fluid {
  padding: 0 15px;
}

.CardBox {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.ProfileBanner {
  background-color: #fff;
  padding: 20px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #000000;
}

.ProfileEditLogo {
  display: flex;
  align-items: center;
}

/* .ProfileEditLogo img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 10px;
} */

.ProfileEditLogo h1 {
  font-size: 18px;
  font-weight: bold;
}

.ProfileEditLogo p {
  color: #6c757d;
  font-size: 14px;
}

button.btn-link {
  background: none;
  border: none;
  color: inherit;
  font-size: 1.5rem;
}

.ProfileDetails {
  padding: 20px;
}

.ProfileDetails h2 {
  font-size: 16px;
  margin-bottom: 10px;
  color: rgba(107, 142, 118, 1);
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: 0.5px;
  font-family: "Poppins", sans-serif;
  /* Apply Poppins */
}

.ProfileDetails p {
  font-size: 14px;
  color: #6c757d;
}

.ProfileDetails .d-flex {
  display: flex;
  align-items: center;
}

.ProfileDetails .d-flex a {
  color: #6c757d;
}

.ProfileDetails .d-flex a:hover {
  text-decoration: underline;
}

.list-unstyled {
  list-style: none;
  padding: 0;
}

.list-unstyled .d-flex {
  margin-bottom: 10px;
}

.list-unstyled .d-flex a {
  color: #6c757d;
}

.list-unstyled .d-flex a:hover {
  color: #007bff;
}

/* Social Links Styles */
.ProfileDetails .d-flex.flex-wrap {
  flex-wrap: wrap;
}

.ProfileDetails .d-flex.flex-wrap a {
  color: #333;
  text-decoration: none;
}

.ProfileDetails .d-flex.flex-wrap a:hover {
  color: #007bff;
}

.ProfileDetails .d-flex.flex-wrap img {
  max-width: 24px;
  height: auto;
  margin-right: 8px;
}

/* Media Queries for Responsiveness */

/* Tablet Devices (Min-width: 768px) */
@media (min-width: 768px) {
  .ProfileBanner {
    padding: 30px;
  }

  .ProfileEditLogo img {
    width: 60px;
    height: 60px;
  }

  .ProfileEditLogo h1 {
    font-size: 22px;
  }

  .ProfileEditLogo p {
    font-size: 16px;
  }

  .ProfileDetails h2 {
    font-size: 18px;
  }

  .ProfileDetails p {
    font-size: 16px;
  }

  .ProfileDetails .d-flex a {
    font-size: 16px;
    line-height: 16px;
  }
}

/* Desktop Devices (Min-width: 1024px) */
@media (min-width: 1024px) {
  .ProfileBanner {
    padding: 40px;
  }

  .ProfileEditLogo img {
    width: 134px;
    height: 134px;
  }

  .ProfileEditLogo h1 {
    font-size: 24px;
  }

  .ProfileEditLogo p {
    font-size: 18px;
  }

  .ProfileDetails h2 {
    font-size: 20px;
  }

  .ProfileDetails p {
    font-size: 18px;
  }

  .ProfileDetails .d-flex a {
    font-size: 18px;
    line-height: 18px;
  }
}

/* Mobile Devices (Max-width: 768px) */
@media (max-width: 767px) {
  .ProfileBanner {
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }

  .ProfileEditLogo {
    text-align: center;
    flex-direction: column;
  }

  .ProfileEditLogo img {
    width: 60px;
    height: 60px;
  }

  .ProfileEditLogo h1 {
    font-size: 18px;
  }

  .ProfileEditLogo p {
    font-size: 14px;
  }

  .ProfileDetails .d-flex {
    flex-direction: column;
    align-items: flex-start;
  }

  .ProfileDetails .d-flex a {
    font-size: 14px;
    padding-left: 10px;
    margin-bottom: 8px;
    line-height: 14px;
  }

  .ProfileDetails .d-flex.flex-wrap {
    justify-content: center;
  }

  .ProfileDetails .d-flex.flex-wrap a {
    flex-basis: 30%;
    justify-content: center;
    margin-bottom: 15px;
  }

  .ProfileDetails .d-flex.flex-wrap img {
    max-width: 20px;
    margin-right: 10px;
  }
}

.ModalBox .modal-body {
  background: #f5f2e7;
  font-family: "Poppins", serif;
}

.ModalBox .TitleTag {
  font-size: 36px;
  font-weight: 500;
  color: #6b8e76;
  text-align: center;
  margin-bottom: 30px;
}

.ModalBox .modal-dialog {
  transform: none;
  max-width: 1090px;
  border-radius: 10px;
}

.ModalBox input,
.ModalBox select {
  border: 2px solid #6b8e76;
  height: 40px;
  color: #676767;
  font-size: 18px;
}

.NaxtPrive .Previous {
  background: #6b8e76;
  padding: 7px 25px;
  font-size: 18px;
  border: 0;
  margin-top: 20px;
  border-radius: 7px;
  color: #fff;
}

.NaxtPrive .Next {
  background: #6b8e76;
  padding: 7px 25px;
  font-size: 18px;
  border: 0;
  margin-top: 20px;
  border-radius: 7px;
  color: #fff;
}

.NaxtPrive .Finish {
  background: #6b8e76;
  padding: 7px 25px;
  font-size: 18px;
  border: 0;
  margin-top: 20px;
  border-radius: 7px;
  color: #fff;
}

.NaxtPrive {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}

.ModalBox .modal-body {
  background: #f5f2e7;
  border-radius: 10px;
}

.ModalBox label.form-label {
  color: #676767;
  font-size: 16px;
  font-weight: 500;
  margin-top: 18px;
}

label.location-title.form-label {
  font-family: "Poppins", sans-serif;
  /* Apply Poppins */
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0.5px;
  text-align: left;
}

/* modal for signup  */

/* Full blur effect */
/* .modal-blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    z-index: 1040;
    
} */

/* Ensure modal is on top */
/* .modal-content {
    position: relative;
    z-index: 1050;
    background: rgba(55, 55, 55, 0.9);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
} */
/* Blur overlay when modal is open */
/* 🔹 Apply blur effect to background when modal is open */
/* 🔹 Apply FULL blur effect to background when modal is open */
/* 🔹 Apply EXTREME blur effect when modal is open */
/* 🔹 Apply EXTREME blur and blackout effect when modal is open */
.modal-blur-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0);
  /* 🔥 Nearly black overlay to block visibility */
  backdrop-filter: blur(10px);
  /* 💀 Ultra blur - Nothing is readable */
  -webkit-backdrop-filter: blur(10px);
  z-index: 1040;
  /* Behind the modal */
}

/* 🔹 Ensure modal content is visible and above the blur */
.modal-content {
  position: relative;
  z-index: 1050;
  background: rgba(55, 55, 55, 1);
  /* Fully solid modal background */
  backdrop-filter: none;
  /* No blur inside modal */
}

/* 🔹 Remove blur when modal is closed */
body:not(.modal-open) .modal-blur-overlay {
  display: none;
  /* Hide overlay when modal is closed */
}

/* categories dropdownnn */
.w-100.p-2.categories-brand.dropdown-menu.show {
  overflow-y: scroll;
  height: 200px;
}

/* end modal for signup  */

.InfluancerCardView .influencer-list .Likes img {
  height: 30px;
}

.CampaignList .card-body {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background: #ffff;
}

.campaignCreate button .img-fluid {
  max-width: 100%;
  height: 15px;
  margin-left: 10px;
  object-fit: contain;
}

.campaignCreate .SearchInput img {
  position: absolute;
  left: 16px;
  top: 15px;
}

.campaignCreate .CreateGreenBtn img {
  filter: brightness(100);
}

.campaignCreate .CreateGreenBtn {
  background: #6b8e76;
  color: #fff;
  padding: 10px 20px;
  border: 0;
  margin-top: 20px;
  border-radius: 10px;
}

.campaignCreate p.text-gray-600.mb-8 {
  color: #676767;
  font-size: 24px;
  padding: 0 30px;
  max-width: 670px;
  line-height: 37px;
}

@media (max-width: 991px) {
  .InfluancerCardView {
    width: 900px;
  }

  .InfluancerCardView .influencer-card {
    display: flex;
    justify-content: space-between;
    background: #fff;
    padding: 20px 50px;
    align-items: center;
    box-shadow: 1px 1px 10px rgb(0 0 0 / 7%);
    border-radius: 15px;
    margin-top: 20px;
  }
}

.FilterHeader i.fa.fa-times {
  position: absolute;
  right: -13px;
  background: #fff;
  height: 30px;
  width: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 50%;
  top: -10px;
  cursor: pointer;
}

ul#weekTabs {
  justify-content: space-between;
  background: #f5f2e7;
  padding: 0 40px;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  background-color: transparent !important;
  border: 0;
  font-weight: 600;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  background-color: transparent !important;
  border: 0;
}

.nav-tabs .nav-item.show .nav-link {
  color: #676767b2 !important;
}

.CampaignTimeLine .Counter {
  border: 1px solid #ddd;
  padding: 10px 10px;
  border-radius: 10px;
  width: 100px;
  display: flex;
  align-items: center;
}

.nav-tabs .nav-link {
  color: #111;
}

.CampaignTimeLine button.btn.btn {
  min-height: 30px;
  font-size: 16px;
  border-radius: 50%;
  min-width: 27px !important;
  background: green;
  color: #ffff;
  line-height: 6px;
  margin: 0;
  display: block;
}

.CampaignTimeLine button.btn.btn {
  height: 20px;
  line-height: 0;
  font-size: 16px;
  padding: 5px;
  display: flex;
  border-radius: 50%;
  width: 20px;
  background: green;
  color: #ffff;
  line-height: 6px;
  justify-content: center;
}

.CampaignTimeLine .d-flex.align-items-center.mb-2 .text-capitalize {
  width: 140px;
  color: #676767;
  font-size: 24px;
  font-weight: 500;
}

.CampaignTimeLine .d-flex.align-items-center.mb-2 {
  margin-bottom: 0.5rem !important;
  justify-content: center;
}

.CreatedCampaigns .campaign-image {
  height: 200px;
  object-fit: cover;
}

.CreatedCampaigns .status-badge {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  color: #00a676;
  align-items: center;
  margin-right: 5px;
}

.CreatedCampaigns .location-text {
  color: #666;
  font-size: 14px;
}

.CreatedCampaigns .date-text {
  color: #666;
  font-size: 14px;
}

.CreatedCampaigns .language-tag {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: #f5f5f5;
  margin-right: 4px;
}

.CreatedCampaigns .campaign-details-btn {
  width: 100%;
  text-align: center;
  padding: 8px;
  border: 1px solid #eee;
  background: white;
  color: #333;
  text-decoration: none;
  transition: background-color 0.3s;
}

.CreatedCampaigns .campaign-details-btn:hover {
  background-color: #f8f8f8;
}

.campaign-card button {
  width: 100%;
  padding: 6px 20px;
  border-radius: 10px;
  color: #6b8e76;
  border: 1px solid #6b8e76 !important;
  background: #fff;
  margin-top: 10px;
}

.CreatedCampaigns .campaign-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  height: 100%;
}

.CreatedCampaigns .campaign-image {
  min-height: 200px;
  object-fit: cover;
  max-height: 200px;
}

.WhiteBox {
  box-shadow: 1px 1px 10px rgb(0 0 0 / 25%);
  padding: 30px;
  background: #fff;
  border-radius: 10px;
}

.Summery ul {
  margin: 0;
  line-height: 31px;
}

.Summery {
  margin-top: 15px;
}

.CampaignTimeLine .nav-tabs {
  margin-bottom: 50px;
}

.CampaignTimeLine .nav-tabs .nav-link::before {
  content: "";
  position: absolute;
  left: 10px;
  transform: translateX(-50%);
  bottom: -15px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 13px solid #89c19b;
  z-index: 1;
}

.CampaignTimeLine .nav-link.active::before,
.CampaignTimeLine .nav-tabs .nav-link.active::after {
  border-bottom: 13px solid #6b8e76 !important;
}

.CampaignTimeLine .nav-tabs .nav-link {
  position: relative;
  bottom: 0px;
}

.CampaignTimeLine .nav-tabs .nav-link::after {
  content: "";
  position: absolute;
  transform: translateX(-50%);
  bottom: -15px;
  width: 0px;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 13px solid #89c29b !important;
  z-index: 1;
  right: -10px;
}

.Prices {
  background: #f5f2e7;
  width: max-content;
  padding: 15px 30px;
  font-size: 24px;
  color: #6b8e76;
  font-weight: 700;
  margin-bottom: 20px;
}

.Prices {
  background: #f5f2e7;
  width: max-content;
  padding: 15px 30px;
  font-size: 24px;
  color: #6b8e76;
  font-weight: 700;
  margin-bottom: 20px;
}

.Summery .OverView {
  display: flex;
}

.Summery .OverView img {
  height: 25px;
  width: 25px;
  position: relative;
  top: 8px;
}

.Summery .OverView ul {
  padding: 0 11px;
}

.Summery .OverView li {
  font-size: 20px;
  color: #6b8e76;
  font-weight: 500;
  line-height: 35px;
}

ul.AudienceOverView li {
  font-size: 20px;
  margin-bottom: 10px;
  color: #6b8e76;
  font-weight: 600;
}

h2.OverViewTitle {
  color: #676767;
  font-size: 24px;
  font-weight: 400;
  padding-bottom: 20px;
  display: block;
  margin-top: 30px;
}

.Summery .OverView ul {
  padding: 0 35px;
}

.campaign-card .p-3 {
  height: 250px;
}

.campaign-card button {
  margin-bottom: 20px !important;
  width: 90%;
  margin: auto;
  display: block;
}

.StatusCamp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.CreatedCampaigns button.nav-link.active:before {
  content: "";
  position: absolute;
  background: #6b8e76;
  height: 3px;
  width: 100px;
  bottom: 0;
}

.CreatedCampaigns button.nav-link.active {
  position: relative;
}

.CreatedCampaigns button.nav-link.active:before {
  content: "";
  position: absolute;
  background: #6b8e76;
  height: 3px;
  width: 84%;
  bottom: 0;
}

.BannerBox {
  margin-bottom: 30px;
}

.BannerBox img {
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
  height: 218px;
}

@media (max-width: 575px) {
  .SearchInput input {
    padding: 10px 20px 10px 60px;
    width: 100%;
  }

  .SearchFilterSection {
    display: flex;
    width: 100%;
  }

  .SearchFilterSection button,
  .SearchFilterSection input {
    margin-left: 0px;
    width: 100%;
  }

  
  
}


button.CollaborateRequest {
  background: #6B8E76;
  color: #fff;
}
/* Success Toast (Green for Added to Favourites) */
.toast-success {
  background-color: #4caf50; /* Green */
  color: white;
}

/* Error Toast (Red for Removed from Favourites) */
.toast-error {
  background-color: #f44336; /* Red */
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/InsocialOrbit/Assets/css/brand.css"],"names":[],"mappings":";AACA;;;EAGE,oCAAoC;AACtC;;AAEA;;;;;;;IAOI;AACJ;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA,2CAA2C;AAC3C;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,oCAAoC;EACpC,4BAA4B;EAC5B;;qCAEmC;EACnC,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;;AAEzB;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;EACxC,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA,iBAAiB;;AAEjB;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kCAAkC;EAClC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;GAMG;;AAEH;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA,qCAAqC;;AAErC,sCAAsC;AACtC;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,sBAAsB;;AAEtB,qBAAqB;AACrB;;;;;;;;;;;GAWG;;AAEH,2BAA2B;AAC3B;;;;;;GAMG;AACH,oCAAoC;AACpC,0DAA0D;AAC1D,+DAA+D;AAC/D,oDAAoD;AACpD,iEAAiE;AACjE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,gDAAgD;EAChD,2BAA2B;EAC3B,wCAAwC;EACxC,mCAAmC;EACnC,aAAa;EACb,qBAAqB;AACvB;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA,0BAA0B;;AAE1B;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,wCAAwC;EACxC,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,iCAAiC;EACjC,UAAU;AACZ;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,4CAA4C;EAC5C,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,4BAA4B;IAC5B,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;;IAEE,gBAAgB;IAChB,WAAW;EACb;;;;AAIF;;;AAGA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA,kDAAkD;AAClD;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,yBAAyB,EAAE,QAAQ;EACnC,YAAY;AACd","sourcesContent":["\ninput,\nselect,\ntextarea {\n  border: 2px solid #6b8e76 !important;\n}\n\n/* .modal-content {\n    max-height: 650px;\n}\n\n.modal-body {\n    max-height: 700px;\n    overflow-y: auto;\n}  */\n.modal-body-scroll {\n  max-height: 60vh;\n  /* Limits height and makes content scroll */\n  overflow-y: auto;\n  padding-top: 60px;\n  /* To prevent overlap with fixed header */\n  padding-bottom: 60px;\n  /* To prevent overlap with fixed footer */\n}\n\n.fixed-top {\n  position: sticky;\n  top: 0;\n  z-index: 1050;\n  padding: 10px;\n}\n\n.fixed-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1050;\n  padding: 10px;\n}\n\n/* modal .dropdown-menu */\n.drop {\n  height: 40px !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n  padding: 10px 15px;\n  font-size: 16px;\n  background-color: white;\n}\n\n/* Blur effect when modal is open */\n.modal-open .main-content {\n  filter: blur(10px);\n  transition: filter 0.3s ease-in-out;\n  pointer-events: none;\n}\n\n/* Enhanced blur effect on modal backdrop */\n.modal-backdrop.show {\n  backdrop-filter: blur(5px);\n  /* Increase blur for better effect */\n  background-color: rgba(0, 0, 0, 0.7);\n  /* Slightly reduce opacity */\n  transition:\n    backdrop-filter 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  pointer-events: auto;\n  /* Ensures clicks outside modal still work */\n}\n\n.drop::after {\n  margin-top: -2px;\n}\n\n.dropdown-menu {\n  width: 100% !important;\n}\n\n/* modal .dropdown-menu */\n\n.ChieldComponent {\n  background-color: #f5f2e7;\n  width: 100%;\n  min-height: 100vh;\n  padding: 30px;\n}\n\n.InfluancerCardView .InfluencerProfile {\n  text-align: center;\n  width: 120px;\n  color: #676767;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.InfluancerCardView .InfluencerProfile h4 {\n  font-size: 20px;\n  margin-top: 10px;\n  display: block;\n  color: #676767;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.InfluancerCardView .InfluencerProfile img {\n  margin-bottom: 10px;\n}\n\n.InfluancerCardView .influencer-card {\n  display: flex;\n  justify-content: space-between;\n  background: #fff;\n  padding: 20px 50px;\n  align-items: center;\n  box-shadow: 1px 1px 10px rgb(0 0 0 / 7%);\n  border-radius: 15px;\n  margin-top: 20px;\n}\n\n.InfluancerCardView .InfluencerFollowes {\n  font-size: 16px !important;\n  font-weight: 500;\n  color: #676767 !important;\n  display: flex;\n  align-items: center;\n  line-height: 20px !important;\n  width: 240px;\n  text-align: center;\n  justify-content: center;\n}\n\n.InfluancerCardView .Shorting label {\n  color: #676767;\n  font-size: 18px;\n  font-weight: 400;\n}\n\n.InfluancerCardView .InfluencerGenre {\n  color: #676767;\n  font-size: 16px;\n  font-weight: 500;\n  width: 150px;\n  text-align: center;\n}\n\n.InfluancerCardView .InfluencerEngagement {\n  width: 150px;\n  color: #676767;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.InfluancerCardView .engagement {\n  width: 200px;\n  text-align: center;\n  color: #676767;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.InfluancerCardView .engagement span {\n  font-size: 24px;\n  color: #6b8e76;\n  font-weight: 600;\n}\n\n.InfluancerCardView .influencer-list {\n  margin-bottom: 20px;\n}\n\n@media (max-width: 767px) {\n  .SearchFilterSection {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.SearchFilterSection {\n  display: flex;\n}\n\n.SearchFilterSection input {\n  width: 260px;\n}\n\n.SearchFilterSection button,\n.SearchFilterSection input {\n  margin-left: 20px;\n  background-color: #fff;\n  box-shadow: 1px 1px 6px rgb(0 0 0 / 10%);\n  border: 0;\n  border-radius: 6px;\n  font-size: 16px;\n  padding: 9px 20px;\n  font-weight: 400;\n  color: #676767;\n}\n\n.InfluancerCardView .InfluencerEngagement p {\n  color: #6b4750;\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 6px !important;\n}\n\n.InfluancerCardView .InfluencerFollowes span.audience-icon {\n  margin-right: 16px;\n}\n\n.InfluancerCardView .influencer-list img {\n  cursor: pointer;\n}\n\n.SearchInput {\n  position: relative;\n}\n\n.SearchInput img {\n  position: absolute;\n  left: 30px;\n  top: 15px;\n}\n\n.SearchInput input {\n  padding: 10px 40px;\n}\n\n.InfluencerGridList {\n  background: #fff;\n  width: max-content;\n  box-shadow: 1px 1px 10px rgb(0 0 0 / 12%);\n  border-radius: 17px;\n  padding: 10px;\n  height: 100%;\n}\n\n/* filter-popup */\n\n.filter-popup {\n  position: fixed;\n  top: 150px;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: end;\n  z-index: 1000;\n}\n\n.filter-popup:before {\n  content: \"\";\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background: #0000009e;\n  min-height: 100vh;\n}\n\n.filter-popup .filter-popup-content {\n  background: #fff;\n  padding: 0px;\n  border-radius: 10px;\n  width: 300px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.filter-popup .filter-popup-content h3 {\n  margin-top: 0;\n}\n\n.filter-popup .close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.filter-popup .clear-btn {\n  position: absolute;\n  top: 10px;\n  right: 40px;\n  background: none;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n  color: white;\n}\n\n.filter-options {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 20px;\n}\n\n.filter-popup .apply-filters-btn {\n  margin-top: 20px;\n  padding: 10px;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.filter-popup .filter-popup-content {\n  background: #f5f2e7;\n  padding: 0px;\n  border-radius: 10px;\n  width: 300px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  position: relative;\n  width: 100%;\n  max-width: 500px;\n  border-radius: 10px;\n  margin-right: 25px;\n}\n\n.filter-popup ul.nav.nav-pills li {\n  display: block;\n  width: 100%;\n  background: #fff;\n}\n\n.filter-popup ul.nav.nav-pills {\n  width: 210px;\n  background: #fff;\n}\n\n.filter-popup ul.nav.nav-pills li {\n  border-bottom: 1px solid #767676;\n}\n\n.filter-popup ul.nav.nav-pills li a {\n  text-decoration: none;\n  color: #676767;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 60px;\n  text-align: center;\n  padding: 0 15px;\n}\n\n.filter-popup ul.nav.nav-pills li {\n  display: block;\n  width: 100%;\n  background: #fff;\n}\n\n.filter-popup ul.nav.nav-pills {\n  width: 210px;\n  background: #fff;\n}\n\n.filter-popup ul.nav.nav-pills li {\n  border-bottom: 1px solid #767676;\n}\n\n.filter-popup ul.nav.nav-pills li a {\n  text-decoration: none;\n  color: #676767;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 60px;\n  text-align: center;\n  padding: 0 15px;\n}\n\n.filter-popup .filter-options label {\n  padding: 8px 0;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.filter-popup .form-check input {\n  height: 20px;\n  width: 20px;\n  margin-right: 10px;\n  border: 3px solid #6b8e76;\n  background: transparent;\n}\n\n.filter-popup .form-check {\n  display: flex;\n  align-items: center;\n}\n\n.filter-popup ul.nav.nav-pills li h6 {\n  padding: 14px 20px;\n  text-align: center;\n  font-size: 20px;\n  color: #6b8e76;\n  font-weight: 600;\n}\n\n.filter-popup .FilterHeader {\n  display: flex;\n  width: 100%;\n  background: #fff;\n  padding: 9px 30px;\n}\n\n.filter-popup button.btn.btn-primary.mt-3 {\n  background: #6b8e76;\n  border: 0;\n  width: max-content;\n  padding: 10px 30px;\n}\n\n.filter-popup .Filters {\n  display: flex;\n  height: 460px;\n  overflow-y: auto;\n}\n\n.filter-popup .FilterHeader {\n  display: flex;\n  width: 100%;\n  background: rgba(107, 142, 118, 1);\n  padding: 9px 30px;\n  border-radius: 10px 10px 0 0;\n}\n\n.filter-popup .form-check {\n  display: flex;\n  align-items: center;\n}\n\n.filter-popup .FilterHeader h6 {\n  width: 113px;\n  color: rgba(245, 242, 231, 1);\n  font-weight: 500;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 20px;\n}\n\n.filter-popup li.SearchFilter input {\n  border: 0;\n}\n\n.filter-popup li.SearchFilter {\n  padding: 5px 20px;\n}\n\n.filter-popup i.SearchFilter img {\n  left: -3px;\n  top: 3px;\n}\n\n.filter-popup li.SearchFilter input {\n  border: 0;\n  padding: 0 26px;\n}\n\n.filter-popup .SearchInput img {\n  position: absolute;\n  left: 0px;\n  top: 3px;\n}\n\n.BtnsGrp {\n  margin-top: auto;\n  /* Pushes the button group to the bottom */\n  padding: 10px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 500;\n  color: rgba(107, 142, 118, 1);\n}\n\n.Shorting .Sort {\n  height: 14px;\n  margin-left: 10px;\n}\n\n.TableBox {\n  height: calc(100vh - 8em);\n  overflow-y: auto;\n}\n\n.Shorting.influencer-list .influencer-card {\n  margin: 0 !important;\n  background: transparent;\n  box-shadow: 0 0 0;\n  padding: 0 0 15px 50px;\n}\n\n.Shorting.influencer-list {\n  margin: 0;\n}\n\n.InfluencerGridList {\n  background: #fff;\n  width: 100%;\n  box-shadow: 1px 1px 10px rgb(0 0 0 / 12%);\n  border-radius: 17px;\n  padding: 10px;\n}\n\n.InfluencerGridList .ImgBox img {\n  width: 100%;\n}\n\n.InfluencerGridList .Name h6 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #676767;\n  padding: 9px 0;\n}\n\n.InfluencerGridList .Name {\n  margin-top: 20px;\n}\n\n.InfluencerGridList .Dats {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.InfluencerGridList .Dats div span {\n  display: block;\n}\n\n.InfluencerGridList .Dats div span {\n  display: block;\n  color: #6b8e76;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.InfluencerGridList .Dats div {\n  text-align: center;\n}\n\n.InfluencerGridList .Dats div strong {\n  color: #676767;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.InfluencerGridList .Dats div .follower-text-lg {\n  color: #0c0c0c;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.SocialPresence {\n  padding: 0 15px;\n}\n\n.InfluencerGridList .Name {\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  padding: 0 15px;\n}\n\n.ImgBox {\n  background: #fbfbfb;\n  border-radius: 15px;\n}\n\n.InfluencerGridList .Dats div {\n  text-align: center;\n}\n\nstrong {\n  color: #676767;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.ImgBox {\n  background: #fbfbfb;\n  border-radius: 15px;\n  position: relative;\n  position: relative;\n}\n\n.Genuine {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 40px;\n  width: 40px;\n  background: #fff;\n  text-align: center;\n  line-height: 36px;\n  border-radius: 50%;\n  border: 2px solid #6b8e76 !important;\n  color: #6b8e76;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.Genuine span {\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  right: -6px;\n  color: #6b8e76;\n  top: -2px;\n  background: #fcfcfc;\n  font-size: 15px;\n  line-height: 15px;\n  border-radius: 50%;\n  font-weight: 700;\n}\n\n.Genuine h6 {\n  font-size: 12px;\n  text-align: center;\n  position: relative;\n  left: -4px;\n  top: 42px;\n  font-weight: 700;\n}\n\n.form-group label {\n  color: #676767;\n  font-size: 24px;\n  font-weight: 500;\n}\n\n.ProfileBanner {\n  background: #fff;\n  padding: 20px 21px;\n  border-radius: 10px;\n  box-shadow: 1px 1px 10px rgb(0 0 0 / 15%);\n  border: 1px solid #111;\n}\n\n.ProfileDetails {\n  box-shadow: 1px 1px 10px rgb(0 0 0 / 15%);\n  background: #fff;\n  border: 1px solid #111;\n  padding: 20px;\n  margin-top: 20px;\n  border-radius: 10px;\n}\n\nh2.h6 {\n  color: #6b8e76;\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: 20px;\n  display: block;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n  display: flex;\n  align-items: center;\n}\n\n.list-unstyled div {\n  margin-right: 30px;\n}\n\n.list-unstyled div a {\n  text-decoration: none;\n}\n\nh2.h6 {\n  color: #6b8e76;\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: 20px !important;\n  display: block;\n  margin-bottom: 15px !important;\n}\n\n.list-unstyled div svg {\n  border: 1px solid #ddd;\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  object-fit: contain;\n  padding: 7px;\n}\n\n.ProfileDetails h1 {\n  position: auto !important;\n}\n\n.ProfileEditLogo img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n  margin-right: 30px;\n  aspect-ratio: 1 / 1;\n}\n\n.ProfileEditLogo {\n  display: flex;\n  align-items: center;\n  font-family: \"Poppins\", serif;\n}\n\n.ProfileEditLogo h1.h5 {\n  font-size: 48px;\n  font-family: \"Poppins\", serif;\n  font-weight: 500;\n  color: #6b8e76;\n}\n\n/* Basic Reset */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.MyProfile {\n  font-family: \"Poppins\", serif;\n}\n\n/* General Styles */\n.container-fluid {\n  padding: 0 15px;\n}\n\n.CardBox {\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.ProfileBanner {\n  background-color: #fff;\n  padding: 20px;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #000000;\n}\n\n.ProfileEditLogo {\n  display: flex;\n  align-items: center;\n}\n\n/* .ProfileEditLogo img {\n    width: 50px;\n    height: 50px;\n    object-fit: cover;\n    border-radius: 50%;\n    margin-right: 10px;\n} */\n\n.ProfileEditLogo h1 {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.ProfileEditLogo p {\n  color: #6c757d;\n  font-size: 14px;\n}\n\nbutton.btn-link {\n  background: none;\n  border: none;\n  color: inherit;\n  font-size: 1.5rem;\n}\n\n.ProfileDetails {\n  padding: 20px;\n}\n\n.ProfileDetails h2 {\n  font-size: 16px;\n  margin-bottom: 10px;\n  color: rgba(107, 142, 118, 1);\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 36px;\n  letter-spacing: 0.5px;\n  font-family: \"Poppins\", sans-serif;\n  /* Apply Poppins */\n}\n\n.ProfileDetails p {\n  font-size: 14px;\n  color: #6c757d;\n}\n\n.ProfileDetails .d-flex {\n  display: flex;\n  align-items: center;\n}\n\n.ProfileDetails .d-flex a {\n  color: #6c757d;\n}\n\n.ProfileDetails .d-flex a:hover {\n  text-decoration: underline;\n}\n\n.list-unstyled {\n  list-style: none;\n  padding: 0;\n}\n\n.list-unstyled .d-flex {\n  margin-bottom: 10px;\n}\n\n.list-unstyled .d-flex a {\n  color: #6c757d;\n}\n\n.list-unstyled .d-flex a:hover {\n  color: #007bff;\n}\n\n/* Social Links Styles */\n.ProfileDetails .d-flex.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.ProfileDetails .d-flex.flex-wrap a {\n  color: #333;\n  text-decoration: none;\n}\n\n.ProfileDetails .d-flex.flex-wrap a:hover {\n  color: #007bff;\n}\n\n.ProfileDetails .d-flex.flex-wrap img {\n  max-width: 24px;\n  height: auto;\n  margin-right: 8px;\n}\n\n/* Media Queries for Responsiveness */\n\n/* Tablet Devices (Min-width: 768px) */\n@media (min-width: 768px) {\n  .ProfileBanner {\n    padding: 30px;\n  }\n\n  .ProfileEditLogo img {\n    width: 60px;\n    height: 60px;\n  }\n\n  .ProfileEditLogo h1 {\n    font-size: 22px;\n  }\n\n  .ProfileEditLogo p {\n    font-size: 16px;\n  }\n\n  .ProfileDetails h2 {\n    font-size: 18px;\n  }\n\n  .ProfileDetails p {\n    font-size: 16px;\n  }\n\n  .ProfileDetails .d-flex a {\n    font-size: 16px;\n    line-height: 16px;\n  }\n}\n\n/* Desktop Devices (Min-width: 1024px) */\n@media (min-width: 1024px) {\n  .ProfileBanner {\n    padding: 40px;\n  }\n\n  .ProfileEditLogo img {\n    width: 134px;\n    height: 134px;\n  }\n\n  .ProfileEditLogo h1 {\n    font-size: 24px;\n  }\n\n  .ProfileEditLogo p {\n    font-size: 18px;\n  }\n\n  .ProfileDetails h2 {\n    font-size: 20px;\n  }\n\n  .ProfileDetails p {\n    font-size: 18px;\n  }\n\n  .ProfileDetails .d-flex a {\n    font-size: 18px;\n    line-height: 18px;\n  }\n}\n\n/* Mobile Devices (Max-width: 768px) */\n@media (max-width: 767px) {\n  .ProfileBanner {\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n  }\n\n  .ProfileEditLogo {\n    text-align: center;\n    flex-direction: column;\n  }\n\n  .ProfileEditLogo img {\n    width: 60px;\n    height: 60px;\n  }\n\n  .ProfileEditLogo h1 {\n    font-size: 18px;\n  }\n\n  .ProfileEditLogo p {\n    font-size: 14px;\n  }\n\n  .ProfileDetails .d-flex {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .ProfileDetails .d-flex a {\n    font-size: 14px;\n    padding-left: 10px;\n    margin-bottom: 8px;\n    line-height: 14px;\n  }\n\n  .ProfileDetails .d-flex.flex-wrap {\n    justify-content: center;\n  }\n\n  .ProfileDetails .d-flex.flex-wrap a {\n    flex-basis: 30%;\n    justify-content: center;\n    margin-bottom: 15px;\n  }\n\n  .ProfileDetails .d-flex.flex-wrap img {\n    max-width: 20px;\n    margin-right: 10px;\n  }\n}\n\n.ModalBox .modal-body {\n  background: #f5f2e7;\n  font-family: \"Poppins\", serif;\n}\n\n.ModalBox .TitleTag {\n  font-size: 36px;\n  font-weight: 500;\n  color: #6b8e76;\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.ModalBox .modal-dialog {\n  transform: none;\n  max-width: 1090px;\n  border-radius: 10px;\n}\n\n.ModalBox input,\n.ModalBox select {\n  border: 2px solid #6b8e76;\n  height: 40px;\n  color: #676767;\n  font-size: 18px;\n}\n\n.NaxtPrive .Previous {\n  background: #6b8e76;\n  padding: 7px 25px;\n  font-size: 18px;\n  border: 0;\n  margin-top: 20px;\n  border-radius: 7px;\n  color: #fff;\n}\n\n.NaxtPrive .Next {\n  background: #6b8e76;\n  padding: 7px 25px;\n  font-size: 18px;\n  border: 0;\n  margin-top: 20px;\n  border-radius: 7px;\n  color: #fff;\n}\n\n.NaxtPrive .Finish {\n  background: #6b8e76;\n  padding: 7px 25px;\n  font-size: 18px;\n  border: 0;\n  margin-top: 20px;\n  border-radius: 7px;\n  color: #fff;\n}\n\n.NaxtPrive {\n  display: flex;\n  justify-content: end;\n  margin-top: 20px;\n}\n\n.ModalBox .modal-body {\n  background: #f5f2e7;\n  border-radius: 10px;\n}\n\n.ModalBox label.form-label {\n  color: #676767;\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 18px;\n}\n\nlabel.location-title.form-label {\n  font-family: \"Poppins\", sans-serif;\n  /* Apply Poppins */\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 36px;\n  letter-spacing: 0.5px;\n  text-align: left;\n}\n\n/* modal for signup  */\n\n/* Full blur effect */\n/* .modal-blur-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.3);\n    backdrop-filter: blur(6px);\n    -webkit-backdrop-filter: blur(6px);\n    z-index: 1040;\n    \n} */\n\n/* Ensure modal is on top */\n/* .modal-content {\n    position: relative;\n    z-index: 1050;\n    background: rgba(55, 55, 55, 0.9);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n} */\n/* Blur overlay when modal is open */\n/* 🔹 Apply blur effect to background when modal is open */\n/* 🔹 Apply FULL blur effect to background when modal is open */\n/* 🔹 Apply EXTREME blur effect when modal is open */\n/* 🔹 Apply EXTREME blur and blackout effect when modal is open */\n.modal-blur-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0);\n  /* 🔥 Nearly black overlay to block visibility */\n  backdrop-filter: blur(10px);\n  /* 💀 Ultra blur - Nothing is readable */\n  -webkit-backdrop-filter: blur(10px);\n  z-index: 1040;\n  /* Behind the modal */\n}\n\n/* 🔹 Ensure modal content is visible and above the blur */\n.modal-content {\n  position: relative;\n  z-index: 1050;\n  background: rgba(55, 55, 55, 1);\n  /* Fully solid modal background */\n  backdrop-filter: none;\n  /* No blur inside modal */\n}\n\n/* 🔹 Remove blur when modal is closed */\nbody:not(.modal-open) .modal-blur-overlay {\n  display: none;\n  /* Hide overlay when modal is closed */\n}\n\n/* categories dropdownnn */\n.w-100.p-2.categories-brand.dropdown-menu.show {\n  overflow-y: scroll;\n  height: 200px;\n}\n\n/* end modal for signup  */\n\n.InfluancerCardView .influencer-list .Likes img {\n  height: 30px;\n}\n\n.CampaignList .card-body {\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  background: #ffff;\n}\n\n.campaignCreate button .img-fluid {\n  max-width: 100%;\n  height: 15px;\n  margin-left: 10px;\n  object-fit: contain;\n}\n\n.campaignCreate .SearchInput img {\n  position: absolute;\n  left: 16px;\n  top: 15px;\n}\n\n.campaignCreate .CreateGreenBtn img {\n  filter: brightness(100);\n}\n\n.campaignCreate .CreateGreenBtn {\n  background: #6b8e76;\n  color: #fff;\n  padding: 10px 20px;\n  border: 0;\n  margin-top: 20px;\n  border-radius: 10px;\n}\n\n.campaignCreate p.text-gray-600.mb-8 {\n  color: #676767;\n  font-size: 24px;\n  padding: 0 30px;\n  max-width: 670px;\n  line-height: 37px;\n}\n\n@media (max-width: 991px) {\n  .InfluancerCardView {\n    width: 900px;\n  }\n\n  .InfluancerCardView .influencer-card {\n    display: flex;\n    justify-content: space-between;\n    background: #fff;\n    padding: 20px 50px;\n    align-items: center;\n    box-shadow: 1px 1px 10px rgb(0 0 0 / 7%);\n    border-radius: 15px;\n    margin-top: 20px;\n  }\n}\n\n.FilterHeader i.fa.fa-times {\n  position: absolute;\n  right: -13px;\n  background: #fff;\n  height: 30px;\n  width: 30px;\n  line-height: 30px;\n  text-align: center;\n  border-radius: 50%;\n  top: -10px;\n  cursor: pointer;\n}\n\nul#weekTabs {\n  justify-content: space-between;\n  background: #f5f2e7;\n  padding: 0 40px;\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n  background-color: transparent !important;\n  border: 0;\n  font-weight: 600;\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n  background-color: transparent !important;\n  border: 0;\n}\n\n.nav-tabs .nav-item.show .nav-link {\n  color: #676767b2 !important;\n}\n\n.CampaignTimeLine .Counter {\n  border: 1px solid #ddd;\n  padding: 10px 10px;\n  border-radius: 10px;\n  width: 100px;\n  display: flex;\n  align-items: center;\n}\n\n.nav-tabs .nav-link {\n  color: #111;\n}\n\n.CampaignTimeLine button.btn.btn {\n  min-height: 30px;\n  font-size: 16px;\n  border-radius: 50%;\n  min-width: 27px !important;\n  background: green;\n  color: #ffff;\n  line-height: 6px;\n  margin: 0;\n  display: block;\n}\n\n.CampaignTimeLine button.btn.btn {\n  height: 20px;\n  line-height: 0;\n  font-size: 16px;\n  padding: 5px;\n  display: flex;\n  border-radius: 50%;\n  width: 20px;\n  background: green;\n  color: #ffff;\n  line-height: 6px;\n  justify-content: center;\n}\n\n.CampaignTimeLine .d-flex.align-items-center.mb-2 .text-capitalize {\n  width: 140px;\n  color: #676767;\n  font-size: 24px;\n  font-weight: 500;\n}\n\n.CampaignTimeLine .d-flex.align-items-center.mb-2 {\n  margin-bottom: 0.5rem !important;\n  justify-content: center;\n}\n\n.CreatedCampaigns .campaign-image {\n  height: 200px;\n  object-fit: cover;\n}\n\n.CreatedCampaigns .status-badge {\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  color: #00a676;\n  align-items: center;\n  margin-right: 5px;\n}\n\n.CreatedCampaigns .location-text {\n  color: #666;\n  font-size: 14px;\n}\n\n.CreatedCampaigns .date-text {\n  color: #666;\n  font-size: 14px;\n}\n\n.CreatedCampaigns .language-tag {\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  margin-right: 4px;\n}\n\n.CreatedCampaigns .campaign-details-btn {\n  width: 100%;\n  text-align: center;\n  padding: 8px;\n  border: 1px solid #eee;\n  background: white;\n  color: #333;\n  text-decoration: none;\n  transition: background-color 0.3s;\n}\n\n.CreatedCampaigns .campaign-details-btn:hover {\n  background-color: #f8f8f8;\n}\n\n.campaign-card button {\n  width: 100%;\n  padding: 6px 20px;\n  border-radius: 10px;\n  color: #6b8e76;\n  border: 1px solid #6b8e76 !important;\n  background: #fff;\n  margin-top: 10px;\n}\n\n.CreatedCampaigns .campaign-card {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  height: 100%;\n}\n\n.CreatedCampaigns .campaign-image {\n  min-height: 200px;\n  object-fit: cover;\n  max-height: 200px;\n}\n\n.WhiteBox {\n  box-shadow: 1px 1px 10px rgb(0 0 0 / 25%);\n  padding: 30px;\n  background: #fff;\n  border-radius: 10px;\n}\n\n.Summery ul {\n  margin: 0;\n  line-height: 31px;\n}\n\n.Summery {\n  margin-top: 15px;\n}\n\n.CampaignTimeLine .nav-tabs {\n  margin-bottom: 50px;\n}\n\n.CampaignTimeLine .nav-tabs .nav-link::before {\n  content: \"\";\n  position: absolute;\n  left: 10px;\n  transform: translateX(-50%);\n  bottom: -15px;\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 13px solid #89c19b;\n  z-index: 1;\n}\n\n.CampaignTimeLine .nav-link.active::before,\n.CampaignTimeLine .nav-tabs .nav-link.active::after {\n  border-bottom: 13px solid #6b8e76 !important;\n}\n\n.CampaignTimeLine .nav-tabs .nav-link {\n  position: relative;\n  bottom: 0px;\n}\n\n.CampaignTimeLine .nav-tabs .nav-link::after {\n  content: \"\";\n  position: absolute;\n  transform: translateX(-50%);\n  bottom: -15px;\n  width: 0px;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 13px solid #89c29b !important;\n  z-index: 1;\n  right: -10px;\n}\n\n.Prices {\n  background: #f5f2e7;\n  width: max-content;\n  padding: 15px 30px;\n  font-size: 24px;\n  color: #6b8e76;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.Prices {\n  background: #f5f2e7;\n  width: max-content;\n  padding: 15px 30px;\n  font-size: 24px;\n  color: #6b8e76;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.Summery .OverView {\n  display: flex;\n}\n\n.Summery .OverView img {\n  height: 25px;\n  width: 25px;\n  position: relative;\n  top: 8px;\n}\n\n.Summery .OverView ul {\n  padding: 0 11px;\n}\n\n.Summery .OverView li {\n  font-size: 20px;\n  color: #6b8e76;\n  font-weight: 500;\n  line-height: 35px;\n}\n\nul.AudienceOverView li {\n  font-size: 20px;\n  margin-bottom: 10px;\n  color: #6b8e76;\n  font-weight: 600;\n}\n\nh2.OverViewTitle {\n  color: #676767;\n  font-size: 24px;\n  font-weight: 400;\n  padding-bottom: 20px;\n  display: block;\n  margin-top: 30px;\n}\n\n.Summery .OverView ul {\n  padding: 0 35px;\n}\n\n.campaign-card .p-3 {\n  height: 250px;\n}\n\n.campaign-card button {\n  margin-bottom: 20px !important;\n  width: 90%;\n  margin: auto;\n  display: block;\n}\n\n.StatusCamp {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.CreatedCampaigns button.nav-link.active:before {\n  content: \"\";\n  position: absolute;\n  background: #6b8e76;\n  height: 3px;\n  width: 100px;\n  bottom: 0;\n}\n\n.CreatedCampaigns button.nav-link.active {\n  position: relative;\n}\n\n.CreatedCampaigns button.nav-link.active:before {\n  content: \"\";\n  position: absolute;\n  background: #6b8e76;\n  height: 3px;\n  width: 84%;\n  bottom: 0;\n}\n\n.BannerBox {\n  margin-bottom: 30px;\n}\n\n.BannerBox img {\n  width: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  height: 218px;\n}\n\n@media (max-width: 575px) {\n  .SearchInput input {\n    padding: 10px 20px 10px 60px;\n    width: 100%;\n  }\n\n  .SearchFilterSection {\n    display: flex;\n    width: 100%;\n  }\n\n  .SearchFilterSection button,\n  .SearchFilterSection input {\n    margin-left: 0px;\n    width: 100%;\n  }\n\n  \n  \n}\n\n\nbutton.CollaborateRequest {\n  background: #6B8E76;\n  color: #fff;\n}\n/* Success Toast (Green for Added to Favourites) */\n.toast-success {\n  background-color: #4caf50; /* Green */\n  color: white;\n}\n\n/* Error Toast (Red for Removed from Favourites) */\n.toast-error {\n  background-color: #f44336; /* Red */\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
